/** Pure-literal `width: '100%'` / `height: '100%'` CSS-shape presets for inline style objects. Consumers can spread the
 * preset to add sibling style props: `{ ...FULL_SIZE_STYLE, borderRadius: borderRadius.none }`. Switching the
 * underlying viewport unit (e.g. `'100%' -> '100dvh'` for mobile safe-area handling) becomes one edit instead of 40+
 * inline literals.
 *
 * Sibling of `const/style-flex-presets.ts` / `style-grid-presets.ts` / `style-text-presets.ts` /
 * `style-button-presets.ts`, and enforced by the same paired rule (`QUAL-STYLE-FLEX-IDIOM-INLINE-001`), whose matcher
 * derives each preset's member-line run, member-key set and prefilter from these records at module load -- but a preset
 * ADDED here is enforced by nothing until it is also named in that rule's hand-maintained `PRESETS` list; the
 * correction to the flat "zero scanner edits" claim, and its measured cost, is spelled once at that list rather than
 * restated on each leaf. This family joined that rule on 2026-08-23; until then it was the
 * one preset leaf shipping with adopters but no forbid-rule arm, and the bypass had regrown to 14 inline sites.
 */

/** Full-width preset: `{ width: '100%' }`. */
export const FULL_WIDTH_STYLE = { width: '100%' } as const;

/** Full-height preset: `{ height: '100%' }`. */
export const FULL_HEIGHT_STYLE = { height: '100%' } as const;

/** Full-size preset: `{ width: '100%', height: '100%' }`. */
export const FULL_SIZE_STYLE = { width: '100%', height: '100%' } as const;
